export enum AppMarketPage {
  MANAGE_APPS = 'manage-apps',
  APP_PAGE = 'app_page',
  CATEGORY = 'category',
  SUB_CATEGORY = 'sub-category',
  COLLECTION = 'collection',
  HOMEPAGE = 'homepage',
  SEARCH_RESULT = 'search-result',
}

export enum inContextAppSectionType {
  SECTION = 'section',
  COLLECTION = 'collection',
}
